<template>
    <main class="page-wrapper" style="background:#fff">
        <Header
            :data="$props"
        />

        <div class="main-content">
            <slot></slot>
        </div>
		
		<Footer :data="$props"/>
		<!-- <FooterTwo  :data="$props"/> -->
		<!-- <FooterThree :data="$props"/> -->
        <!-- <Footer v-if="footerStyle === 1" :data="$props"/>
        <FooterTwo v-if="footerStyle === 2" :data="$props"/>
        <FooterThree v-if="footerStyle === 3" :data="$props"/> -->
    </main>
</template>

<script>
    import Header from './header/NewHeader'
    import Footer from './footer/NewFooter'
    import FooterTwo from './footer/FooterTwo'
    import FooterThree from './footer/FooterThree'

    export default {
        name: 'Layout',
        components: {FooterThree, FooterTwo, Header, Footer},
        props: {
            logo: {
                type: String
            },
            showTopHeader: {
                type: Boolean,
                default: true
            },
            topbarStyle: {
                type: Number,
                default: 1
            },
            showThemeSwitcherButton: {
                type: Boolean,
                default: false
            },
            headerTransparency: {
                type: Boolean,
                default: false
            },
            headerClass: {
                type: String
            },
            navAlignment: {
				//控制nav 左右
                type: String,
                default: 'right'
            },
            buyButtonClass: {
                type: String,
                default: 'btn-default btn-small'
            },
            footerStyle: {
                type: Number,
                default: 1
            },
            showFooter: {
                type: Boolean,
                default: true
            },
            showCopyright: {
                type: Boolean,
                default: true
            },
            showNewsletter: {
                type: Boolean,
                default: true
            },
            showCta: {
                type: Boolean,
                default: true
            }
        }
    }
</script>